import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Users, ArrowRight, Award, Camera, ShoppingBag } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

 const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return new Date(dateStr);
    const [year, month, day] = parts.map(Number);
    return new Date(year, month - 1, day);
  };

  const formatEventDate = (dateStr) => {
    const d = parseDate(dateStr);
    if (!d) return '';
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
  };

const Home = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${API}/events?status=active`);
        // Ordenar eventos por data mais próxima
        const sortedEvents = response.data.sort((a, b) => {
          const dateA = parseDate(a.date);
          const dateB = parseDate(b.date);
          return dateA - dateB; // Ordem crescente: datas mais próximas primeiro
        });
        setUpcomingEvents(sortedEvents.slice(0, 3));
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  return (
    <div data-testid="home-page">
      <section
        data-testid="hero-section"
        className="relative h-[600px] md:h-[700px] bg-cover bg-center"

        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1780059654084-254513858be9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxtb3VudGFpbiUyMGJpa2UlMjByYWNlJTIwYWN0aW9ufGVufDB8fHx8MTc3MDIzNzA0NHww&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/40 to-primary"></div>
        <div className="relative h-full flex items-center px-6 md:px-12 lg:px-24">
          <div className="max-w-4xl">
            <h1 data-testid="hero-title" className="text-6xl md:text-8xl font-heading font-black tracking-tighter uppercase text-white text-shadow-sm mb-6">
              DESAFIE SEUS LIMITES
            </h1>
            <p data-testid="hero-subtitle" className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl leading-relaxed">
              Participe das corridas mais emocionantes.
            </p>
            <Link
              to="/events"
              data-testid="hero-cta-button"
              className="inline-flex items-center gap-3 bg-destructive text-destructive-foreground hover:bg-destructive/90 uppercase tracking-widest font-bold px-8 py-4 rounded-sm transition-all hover:translate-x-1 hover:-translate-y-1 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
            >
              Ver Eventos
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      <section data-testid="upcoming-events-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="mb-12">
          <h2 className="text-4xl md:text-6xl font-heading font-black tracking-tight uppercase text-primary mb-4">
            Próximos Eventos
          </h2>
          <p className="text-base md:text-lg text-foreground/70 max-w-2xl">
            Inscreva-se agora e garanta sua vaga nas competições mais aguardadas da temporada.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-96 bg-secondary/50 animate-pulse rounded-lg"></div>
            ))}
          </div>
        ) : upcomingEvents.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {upcomingEvents.map((event) => (
              <Link
                key={event.id}
                to={`/events/${event.id}`}
                data-testid={`event-card-${event.id}`}
                className="group relative overflow-hidden bg-card border border-border hover:border-accent transition-all duration-300 hover:shadow-xl rounded-lg"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={event.image_url}
                    alt={event.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-heading font-bold uppercase mb-2 text-primary">
                    {event.name}
                  </h3>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 text-sm text-foreground/70">
                      <Calendar className="w-4 h-4" />
                      {formatEventDate(event?.date)}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-foreground/70">
                      <MapPin className="w-4 h-4" />
                      {event.location}
                    </div>
                    { /* 
                    <div className="flex items-center gap-2 text-sm text-foreground/70">
                      <Users className="w-4 h-4" />
                      {event.current_participants}/{event.max_participants} inscritos
                    </div>
                    */}
                  </div>
                  <div className="flex items-center justify-between">
                    { /* 
                      Habilitar a linha abaixo para voltar a exibir o preco
                    
                    */}
                   {/* <span className="text-2xl font-bold text-accent">R$ {event.price.toFixed(2)}</span> */}
                    <span className="text-xs uppercase tracking-widest font-bold text-primary bg-secondary px-3 py-1 rounded-sm">
                      {event.category}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <p className="text-center text-foreground/50 py-12">Nenhum evento disponível no momento.</p>
        )}

        <div className="mt-12 text-center">
          <Link
            to="/events"
            data-testid="view-all-events-button"
            className="inline-flex items-center gap-3 border-2 border-primary text-primary hover:bg-primary hover:text-white uppercase tracking-widest font-bold px-8 py-4 rounded-sm transition-all"
          >
            Ver Todos os Eventos
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <section data-testid="features-section" className="py-24 md:py-32 bg-secondary px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div data-testid="feature-events" className="bg-white/50 backdrop-blur-sm border border-white/20 p-8 hover:bg-white transition-colors rounded-lg">
            <Award className="w-12 h-12 text-accent mb-4" strokeWidth={1.5} />
            <h3 className="text-2xl font-heading font-bold uppercase mb-3 text-primary">Competições</h3>
            <p className="text-base text-foreground/70 leading-relaxed">
              Eventos profissionais e amadores em trilhas desafiadoras com categorias para todos os níveis.
            </p>
          </div>
          <div data-testid="feature-results" className="bg-white/50 backdrop-blur-sm border border-white/20 p-8 hover:bg-white transition-colors rounded-lg">
            <Camera className="w-12 h-12 text-accent mb-4" strokeWidth={1.5} />
            <h3 className="text-2xl font-heading font-bold uppercase mb-3 text-primary">Galeria</h3>
            <p className="text-base text-foreground/70 leading-relaxed">
              Fotos profissionais de todos os eventos para você reviver os melhores momentos.
            </p>
          </div>
          <div data-testid="feature-store" className="bg-white/50 backdrop-blur-sm border border-white/20 p-8 hover:bg-white transition-colors rounded-lg">
            <ShoppingBag className="w-12 h-12 text-accent mb-4" strokeWidth={1.5} />
            <h3 className="text-2xl font-heading font-bold uppercase mb-3 text-primary">Loja</h3>
            <p className="text-base text-foreground/70 leading-relaxed">
              Produtos exclusivos dos eventos: bonés, camisetas e muito mais.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
